import { render, staticRenderFns } from "./ItemFileCreate.vue?vue&type=template&id=53ba1050&"
import script from "./ItemFileCreate.vue?vue&type=script&lang=js&"
export * from "./ItemFileCreate.vue?vue&type=script&lang=js&"
import style0 from "./ItemFileCreate.vue?vue&type=style&index=0&id=53ba1050&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports